import Breadcrumb from "../utlis/Breadcrumb";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import HeadingPage from "../utlis/HeadingPage";
function Library() {
  return (
    <>
      {/* ================= HEADER ================= */}
      <Header />

      {/* ================= BREADCRUMB / INNER SLIDER ================= */}
      <div className="InnerSld">
        <Breadcrumb
          img="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/page-title.jpg"
          title="Library Rules"
          title2=""
          parentTitle="Academic"
          path="Library Rules"
        />
      </div>

      {/* ================= ABOUT CONTENT ================= */}
      <div className="innerbody">
        <div className="container-fluid">
          <div className="contact-form-card manage">
            <h2 className="about-title">Library Rules</h2>

            <div className="about-content-card">
              <div className="affiliation-list mt-3">
                <div className="affiliation-item">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    <strong>
                      “The real purpose of books is to trap the mind into doing
                      its own thinking” — Christopher Marlowe.
                    </strong>
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    Books from the library will be issued to the students during
                    the library periods as assigned in the class timetable. Only
                    one book will be issued at a time.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    All books must be entered in the library register before
                    they are taken from the library.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    Books are issued to the borrower only. Hence, students may
                    not lend or exchange them with classmates.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    Books may not be kept for more than 7 days. Failure to
                    return a book on expiry of the maximum period of 14 days
                    will involve the payment of a fine of Rs. 100/- per day.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    The borrower who loses a book will have to pay the full
                    price of the book.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    All library books must be returned one month before the
                    Terminal and Final Examinations.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ================= FOOTER ================= */}
      <Footer />
    </>
  );
}

export default Library;
